import React, { useState } from "react";
import { MediaObject } from "../../types/MediaObject";
import { Stack } from "@mui/material";
import DisplayMediaObject from "../MediaObjectSection/DisplayMediaObject";
import { AttachFile, FaxOutlined, ScannerOutlined, SendOutlined } from "@mui/icons-material";

type DisplayableMediaObjectProps = {
  mediaObject: MediaObject;
  label?: string;
};
export default function DisplayableMediaObject({ mediaObject }: DisplayableMediaObjectProps) {
  const [displayMediaObjectOpen, setDisplayMediaObjectOpen] = useState<boolean>(false);
  return (
    <>
      <Stack
        direction="row"
        spacing={1}
        onClick={() => setDisplayMediaObjectOpen(true)}
        sx={{
          alignItems: "center",
          cursor: "pointer"
        }}>
        {mediaObject.fieldname === "fax" && <FaxOutlined />}
        {mediaObject.fieldname === "bea" && <SendOutlined />}
        {mediaObject.fieldname === "scan" && <ScannerOutlined />}
        <AttachFile />
      </Stack>
      <DisplayMediaObject
        mediaObject={displayMediaObjectOpen ? mediaObject : null}
        closeDialog={() => setDisplayMediaObjectOpen(false)}
      />
    </>
  );
}
